import { render, staticRenderFns } from "./OrdersChart.vue?vue&type=template&id=71698af1&"
import script from "./OrdersChart.vue?vue&type=script&lang=ts&"
export * from "./OrdersChart.vue?vue&type=script&lang=ts&"
import style0 from "./OrdersChart.vue?vue&type=style&index=0&module=true&lang=stylus&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports